import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars';
import $ from 'jquery';
import './Leftsidebar.css';
import { LanguageConsumer, Translate } from '../../contexts/LanguageContext';
import { AuthConsumer } from '../../contexts/AuthContext';

let activeTab = window.location.pathname.replace('/', '');

if (activeTab.indexOf('/'))
    activeTab = activeTab.split('/')[0];

class SideBar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            Tab: activeTab
        };
    }
    setActiveTab = (tab) => {
        this.setState({ Tab: tab });
        if ($(window).width() < 1025)
            $('body').addClass('enlarged');
    }
    componentDidMount() {

        if ($(window).width() < 1025) {
            $('body').addClass('enlarged');
        } else {
            $('body').removeClass('enlarged');

        }

        $('.button-menu-mobile').on('click', function (event) {
            event.preventDefault();
            $("body").toggleClass("enlarged");
        });
    }

    render() {
        return (
            <LanguageConsumer>
                {() => (
                    <AuthConsumer>
                        {({ logoutHandler, history }) => {
                            return (
                                <div className="left side-menu">
                                    <Scrollbars style={{ height: 980 }} >
                                        <div>
                                            <div id="sidebar-menu">
                                                <ul className="metismenu" id="side-menu">
                                                    {/* <li className="menu-title">{Translate('Main')}</li> */}
                                                    <li>
                                                        <Link to="/Home" className={this.state.Tab === 'Home' || this.state.Tab === '' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'Home')}>
                                                            <i className="fas fa-home"></i> <span> {Translate('Home')} </span>
                                                        </Link>
                                                    </li>
                                                    <li className="menu-title">{Translate('Money Transfer')}</li>
                                                    <li>
                                                        <Link to="/deposit" className={this.state.Tab === 'deposit' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'deposit')}>
                                                            <i className="fas fa-wallet"></i><span> {Translate('Deposit')} </span>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/withdrawal" className={this.state.Tab === 'withdrawal' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'withdrawal')}>
                                                            <i className="fas fa-money-bill-alt"></i><span> {Translate('Withdrawal')} </span>
                                                        </Link>
                                                    </li>

                                                    <li>
                                                        <Link to="/internal-transfer" className={this.state.Tab === 'internal-transfer' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'internal-transfer')}>
                                                            <i className="fas fa-exchange-alt"></i><span> {Translate('Internal Transfer')} </span>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/bank-account" className={this.state.Tab === 'bank-account' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'bank-account')}>
                                                            <i className="fas fa-university"></i><span> {Translate('Bank Account')} </span>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/campaign" className={this.state.Tab === 'campaign' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'campaign')}>
                                                            <i className="fas fa-gifts"></i><span> {Translate('Campaign')} </span>
                                                        </Link>
                                                    </li>
                                                    <li className="menu-title">{Translate('Accounts')}</li>
                                                    <li>
                                                        <Link to="/user-accounts" className={this.state.Tab === 'user-accounts' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'user-accounts')}>
                                                            <i className="fas fa-users"></i><span> {Translate('User Accounts')} </span>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/account-history" className={this.state.Tab === 'account-history' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'account-history')}>
                                                            <i className="fas fa-history"></i><span> {Translate('Account History')} </span>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/my-documents" className={this.state.Tab === 'my-documents' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'my-documents')}>
                                                            <i className="fas fa-copy"></i><span> {Translate('My Documents')} </span>
                                                        </Link>
                                                    </li>
                                                    <li className="menu-title">{Translate('Other')}</li>
                                                    <li>
                                                        <Link to="/research" className={this.state.Tab === 'research' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'research')}>
                                                            <i className="fas fa-chart-line"></i><span> {Translate('Research')} </span>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <a href="#top" className="waves-effect" onClick={(e) => logoutHandler(e)}>
                                                            <i className="ti-power-off"></i><span>{Translate('Logout')}</span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="clearfix"></div>
                                        </div>
                                    </Scrollbars>
                                </div>
                            )
                        }}
                    </AuthConsumer>
                )}
            </LanguageConsumer>
        );
    }
}

export default SideBar;